import { Component, OnInit } from '@angular/core';
import { File} from '../../../_models/file';
import { CuttingTable } from '../../../_models/cutting_table';
import { Easel } from '../../../_models/easel';
import { Workstep} from '../../../_models/workstep';
import { OptiPiece } from '../../../_models/opti_piece';
import { OptiSheet } from '../../../_models/opti_sheet';
import * as fromFile from '../../../file/state/file.reducer';
import * as fileActions from '../../../file/state/file.actions';
import * as fromOpti from '../../../opti/state/opti.reducer';
import * as optiActions from '../../../opti/state/opti.actions';
import * as fromCuttingTable from '../../../maestros/cutting_table/state/cutting_table.reducer';
import * as cutting_tableActions from '../../../maestros/cutting_table/state/cutting_table.actions';
import * as fromEasel from '../../../maestros/easel/state/easel.reducer';
import * as easelActions from '../../../maestros/easel/state/easel.actions';
import * as fromOptiPiece from '../../../opti/state/opti.reducer';
import * as optiPieceActions from '../../../opti/state/opti.actions';

import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

// Importaciones para la carga de los parámetros generales.
import { Parameter} from '../../../_models/parameter';
import * as fromParameter from '../../../parameter/state/parameter.reducer';
import * as parameterActions from '../../../parameter/state/parameter.actions';

@Component({
  templateUrl: './file-shell.component.html'
})

export class FileShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    file$: Observable<File>;
    infoList$: Observable<any>;
    optiPieceList$: Observable<any>;
    pieceList$: Observable<any>;
    currentOpti$: Observable<any>;
    fileList$: Observable<File[]>;
    easelList$: Observable<Easel[]>;
    workstepsList$: Observable<Workstep[]>;
    parameters$: Observable<Parameter[]>;
    cuttingTables$: Observable<CuttingTable[]>;
    chargeOpti$: Observable<OptiPiece[]>;
    chargeSheetOpti$: Observable<OptiSheet[]>;
    lastExportedFileName$: Observable<any>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromFile.State>
  ) {
    // Se cargan los parámetros generales.
    this.store.dispatch( new parameterActions.LoadParameters({setup_user: 'Cut'}));

    // Se cargan las mesas existentes para el entorno actual. Es para poder
    // obtener luego la ruta destino de la mesa en caso de que tuviese una.
    this.store.dispatch( new cutting_tableActions.LoadCuttingTables(null));

    // Se cargan los caballetes
    this.store.dispatch( new easelActions.LoadEasels({setup_user: 'Cut', f_type: 3, f_active: false}));

    // Se cargan los "pasos de trabajo" de las mesas (worksteps).
    this.store.dispatch( new fileActions.LoadWorksteps(null));
  }

  ngOnInit() {

    // this.file$ = this.store.pipe(select(fromFile.getCurrentFile)) as Observable<File>;

    this.infoList$ = this.store.pipe(select(fromFile.getInfoList)) as Observable<any>;

    // Leer información de las piezas resultantes de optimizaciones.
    this.optiPieceList$ = this.store.pipe(select(fromFile.getOptiPieceList)) as Observable<any>;
    
    // Leer información de las piezas en VS-Floor.
    this.pieceList$ = this.store.pipe(select(fromFile.getPieceList)) as Observable<any>;
    
    // Leer información de las piezas que hay que cargar de la optimización actual.
    this.chargeOpti$ = this.store.pipe(select(fromOptiPiece.getChargeOpti)) as Observable<OptiPiece[]>;
    this.chargeSheetOpti$ = this.store.pipe(select(fromOptiPiece.getChargeSheetOpti)) as Observable<OptiSheet[]>;

    // Lee el ID de la última optimización guardada.
    this.currentOpti$ = this.store.pipe(select(fromOpti.getCurrentOpti)) as Observable<any>;

    // this.fileList$ = this.store.pipe(select(fromFile.getFileList)) as Observable<File[]>;

    this.easelList$ = this.store.pipe(select(fromEasel.getEaselList)) as Observable<any>;
    this.workstepsList$ = this.store.pipe(select(fromFile.getWorkstepsList)) as Observable<any>;

    this.parameters$ = this.store.pipe(select(fromParameter.getParameterList)) as Observable<Parameter[]>;

    this.cuttingTables$ = this.store.pipe(select(fromCuttingTable.getCuttingTableList)) as Observable<CuttingTable[]>;
    
    // Va a contener el nombre del último archivo exportado.
    this.lastExportedFileName$ = this.store.pipe(select(fromFile.getLastExportedNameFile)) as Observable<any>;

  }

  saveFile(fileIn: File): void {

    console.log('---> saveFile fileIn:');
    console.log(fileIn);

    this.store.dispatch( new fileActions.CreateFile(fileIn));

    // if (fileIn.id === null) {
    //   console.log('Se van a CREAR unas entradas importadas desde archivo.');
    //   this.store.dispatch( new fileActions.CreateFile(fileIn));
    // } else {
    //   console.log('Se van a MODIFICAR unas entradas importadas desde archivo.');
    //   this.store.dispatch( new fileActions.UpdateFile(fileIn));
    // }
  }
  
  setExportedFileName(dataIn: any): void {

    console.log('---> file-shell SetExportedFileName dataIn:');
    console.log(dataIn);

    this.store.dispatch( new fileActions.SetExportedFileName(dataIn));
  } // End function SetExportedFileName.

  // ----------- FUNCIONES INFORMACIÓN PIEZAS OPTIMIZACIÓN -----------
  // Función que guarda en base de datos la información obtendida
  // en la optimización para cada una de las piezas resultantes.
  saveOptiPiece(dataIn: any): void {

    console.log('---> file-shell saveOptiPiece dataIn:');
    console.log(dataIn);

    this.store.dispatch( new optiPieceActions.SaveOptiPiece(dataIn));
  }

  // Función que obtiene información de piezas ya optimizadas y guardadas en BD.
  loadOptiPiece(searchParamIn: any): void {

    console.log('---> file-shell loadOptiPiece searchParamIn:');
    console.log(searchParamIn);

    this.store.dispatch( new fileActions.LoadOptiPiece(searchParamIn));
  }
  
  // Función que obtiene información de piezas en VS-Floor.
  loadPiece(searchParamIn: any): void {

    console.log('---> file-shell loadPiece searchParamIn:');
    console.log(searchParamIn);

    this.store.dispatch( new fileActions.LoadPiece(searchParamIn));
  }

  loadChargeOptiById(dataIn: any): void {
    if (!dataIn || !dataIn.opti_id) {
      return;
    }

    this.store.dispatch(new optiActions.ChargeOpti({ opti_id: dataIn.opti_id }));
  }

  // ----------- FIN FUNCIONES INFORMACIÓN PIEZAS OPTIMIZACIÓN -----------

  updateFile(fileIn: any): void {

    console.log('---> updateFile fileIn:');
    // console.log(fileFileIn);

    if (fileIn !== null) {
      console.log('Se va a CARGAR un fichero.');
      this.store.dispatch( new fileActions.UpdateFile(fileIn));
    } else {
      console.log('No existen datos de fichero para cargar.');
    }
  }

  optimizerFile(fileIn: any): void {

    console.log('---> optimizerFile fileIn:');
    console.log(fileIn);

    if (fileIn !== null) {
      console.log('Se va a OPTIMIZAR un fichero.');
      this.store.dispatch( new fileActions.OptimizerFile(fileIn));
    } else {
      console.log('No existen datos de fichero para optimizar.');
    }
  }

  infoFileList(fileIn: any): void {

    console.log('---> infoFileList fileIn:');
    console.log(fileIn);

    if (fileIn !== null) {
      console.log('Se va a obtener el listado de directorios a optimizar.');
      this.store.dispatch( new fileActions.InfoFileList(fileIn));
    } else {
      console.log('No existen datos de listado de ficheros para optimizar.');
    }
  }

  printSheets(sheetListIn: any): void {
    console.log('---> printSheets shell sheetListIn:');
    console.log(sheetListIn);

    this.store.dispatch( new fileActions.PrintSheets(sheetListIn));

  } // End function printSheets

  printEasels(easelListIn: any): void {
    console.log('---> printEasels shell easelListIn:');
    console.log(easelListIn);

    this.store.dispatch( new fileActions.PrintEasels(easelListIn));

  } // End function printEasels

  // -------------------------------------------------
  //  FUNCIONES PARA LA ESCRITURA/LECTURA DE FICHEROS
  // -------------------------------------------------

  readFile(params) {

    console.log('** -> Shell readFile params:');
    console.log(params);

    this.store.dispatch( new fileActions.ReadCsv(params));

  } // End function readFile

  // Función para añadir un nuevo Tracking al listado de acciones.
  makeCsvFile(params): void {

    console.log('---> makeCsvFile:');
    console.log(params);

    this.store.dispatch( new fileActions.MakeCsv(params));

  } // End function makeCsvFile

  // Función para vaciar/resetear la lista de ficheros en Redux.
  resetFileList(params): void {

    console.log('---> resetFileList:');
    console.log(params);

    this.store.dispatch( new fileActions.ResetFileList());

  } // End function resetFileList

  // -----------------------------------------
  // Función para el manejo de archivos CSV
  updateFileCSV(fileIn: any): void {

    console.log('---> updateFileCSV fileIn:');
    // console.log(fileIn);

    if (fileIn !== null) {
      console.log('Se va a CARGAR un fichero.');
      // Mete la información pasada como parámetro en la base de datos.
      // this.store.dispatch( new budgetActions.UpdateFileCSV(fileIn));

      // Actualizamos la vista introduciendo "posiciones" en el presupuesto
      // con los datos pasados como parámetros (que son los leídos desde un fichero).
      console.log('---> updateFileCSV: Actulizando con elementos leídos desde archivo...');

    } else {
      console.log('No existen datos de fichero para cargar.');
    }
  }


  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando file-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal

  // Función para "mostrar/ocultar" el icono de "carga" que bloquea la página.
  changingLoading(value: boolean) {
      console.log('---->>>>.... file-shell ejecutando changingLoading: ' + value);
      this.storeRoot.dispatch( new rootActions.ChangeLoading6(value));
  } // End function changingLoading
  
  // Función para "mostrar/ocultar" el icono de "carga" que bloquea la página.
  changingLoading2(value: boolean) {
      console.log('---->>>>.... file-shell ejecutando changingLoading2: ' + value);
      this.storeRoot.dispatch( new rootActions.ChangeLoading5(value));
  } // End function changingLoading


} // End class FileShellComponent
